import { render, staticRenderFns } from "./NewsDetailsThree.vue?vue&type=template&id=7c223b41"
import script from "./NewsDetailsThree.vue?vue&type=script&lang=js"
export * from "./NewsDetailsThree.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsThree.vue?vue&type=style&index=0&id=7c223b41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports